import NewModal from "../../../../../../documents/modals/NewModal";
import {
  faFileInvoice,
  faHandshake,
  faShoppingCart,
  faAdd,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import billingApi from "@serie3/freelancesplaceapi/api/finance/out";
import FinanceCardRow from "./FinanceCardRow";
import { btn, btnHoverStyle } from "../../../../../../../../layout/Buttons/buttonStyles";

const tabs = [
  { key: "bills", label: "Bills", icon: faFileInvoice },
  { key: "offers", label: "Offers", icon: faHandshake },
  { key: "orders", label: "Orders", icon: faShoppingCart },
];

const FinancePicker = ({ show, setShow, formik, direction }) => {
  const [bills, setBills] = useState([]);
  const [offers, setOffers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("bills");

  const dataMap = { bills, offers, orders };
  const setDataMap = { bills: setBills, offers: setOffers, orders: setOrders };

  const loadDataFunction = async (type) => {
    if (dataMap[type].length > 0) return;
    const response = await billingApi.getAll(type, direction);
    setDataMap[type](response.data.finanzvorgang);
  };

  useEffect(() => {
    if (show) loadDataFunction("bills");
  }, [show]);

  const switchTab = (key) => {
    setActiveTab(key);
    loadDataFunction(key);
  };

  const onHide = () => {
    setBills([]);
    setActiveTab("bills");
  };

  const AddButton = ({ financeId }) => (
    <>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        style={{ ...btn.base, ...btn.success }}
        onClick={() => {
          const newFinance = { id: financeId };
          formik.values.finance.push(newFinance);
          formik.handleSubmit();
        }}
      >
        <FontAwesomeIcon icon={faAdd} /> Add
      </button>
    </>
  );

  return (
    <NewModal show={show} setShow={setShow} onHide={onHide} title="Add Finance Item">
      {/* Tab bar */}
      <div style={{ display: "flex", gap: "6px", marginBottom: "20px", borderBottom: "2px solid #f0f0f0", paddingBottom: "12px" }}>
        {tabs.map(({ key, label, icon }) => {
          const active = activeTab === key;
          return (
            <button
              key={key}
              onClick={() => switchTab(key)}
              style={{
                flex: 1,
                padding: "8px 12px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: active ? 700 : 500,
                fontSize: "0.88rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                background: active ? "#1a73e8" : "#f5f5f5",
                color: active ? "#fff" : "#424242",
                transition: "background 0.15s, color 0.15s",
              }}
            >
              <FontAwesomeIcon icon={icon} />
              {label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      <FinanceCardRow financeArray={dataMap[activeTab]} AddButton={AddButton} />
    </NewModal>
  );
};

export default FinancePicker;
